/**
 * 文件下载
 * @param {*} res
 */
// export function downLoadFiles(res) {
//   let headers = res.headers;
//   var disposition = headers["content-disposition"];
//   // 文件名
//   var fileName = decodeURI(disposition.substring(disposition.indexOf("filename*=") + 17, disposition.length));
//   let blob = new Blob([res.data], { type: headers["content-type"] });
//   let link = document.createElement("a");
//   let url = window.URL.createObjectURL(blob);
//   link.href = url;
//   link.download = fileName;
//   link.click();
//   link.remove();
//   window.URL.revokeObjectURL(blob);
// }
/**
 * 文件下载
 * @param {*} res 数据
 * @param {*} customName 名称
 * @param {*} type 文件或者链接地址
 */
export function downLoadFiles(res, customName = '', type = '') {
  const link = document.createElement("a");
  if(type === 'link'){
      link.href = res;
      let n = res.split('/')[res.split('/').length - 1];
      let fileName = n.split('.')[0];
      let name = customName ? customName : decodeURIComponent(fileName);
      link.download = `${name}`;
      console.log(link);
      let resList = res.split('.');
      let ext = resList[resList.length -1];
      let isImg = isAssetTypeAnImage(ext);
      if(isImg){
          link.target = '_blank';
      }
  } else{
      let url = '';
      if(res.data){
          url = window.URL.createObjectURL(res.data);
      }else{
          url = window.URL.createObjectURL(res);
      }

      link.href = url;
      let name = customName;
      let timeStamp = new Date().getTime(); 
      if(res.headers['content-disposition']){
          let headName = res.headers['content-disposition'].split('filename=')[1];
          name = decodeURIComponent(headName);
          link.download = `${name}`;
      }else{
          link.download = `${name}-${timeStamp}.xlsx`;
      }
  }
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // const url = window.URL.createObjectURL(res);
  // open(url, '_blank');
}

/**
 * 文件下载
 * @param {*} urls 数据
 * @param {*} fileName 名称
 */
export function downladUrl (urls, fileName) {
  const x = new window.XMLHttpRequest();
  x.open('GET', urls, true);
  x.responseType = 'blob';
  x.onload = () => {
      const url = window.URL.createObjectURL(x.response);
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank'
      if(fileName){
          a.download = fileName;
      }else{
          let newFileName = urls.split('/')[urls.split('/').length - 1];
          a.download = newFileName;
      }
      a.style.display = 'none'
      document.body.append(a);
      a.click();
      document.body.removeChild(a);
  };
  x.send();
}

// 保留小数点一位小数（后面直接舍去，不四舍五入）
export function getBit(value, bit = 2) {
  let str = typeof value !== "string" ? value.toString() : value;
  let strIndex = str.indexOf(".");
  if (strIndex === -1) return Number(str);
  str = str.substring(0, strIndex + bit);
  return Number(str);
}

/**
 * 对象转formdata格式
 * @param {*} config
 * @param {*} isEmpty:是否保留空字符属性
 */
export function jsToFormData(config, isEmpty = true) {
  let formData = new FormData();
  let obj = config;

  for (var i in obj) {
      // if (isEmpty && (obj[i] === '' || obj[i] === undefined)) {
      if (isEmpty && (obj[i] === undefined || obj[i] === '' || obj[i] === null)) {
        // formData.append(i, obj[i]);
        continue;
      }
      if (obj[i] instanceof Array) {
          obj[i].map(item => {
              formData.append(i, item);
          });
      } else if (obj[i] instanceof FileList) {
          //filelist 文件类型的处理
          for (var fileItem = 0; fileItem < obj[i].length; fileItem++) {
              formData.append(i, obj[i].item(fileItem));
          }
      } else {
          formData.append(i, obj[i]);
      }
  }
  return formData;
}

export function downLoadFilesName(res, name = '', type = '') {
  const link = document.createElement("a");
  if(type === 'link'){
      link.href = res;
  } else{
      const url = window.URL.createObjectURL(res);
      link.href = url;
  }
  let timeStamp = new Date().getTime(); 
  link.download = `${name}-${timeStamp}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

// 判断图片
export function isAssetTypeAnImage(type){
    // let type = fileName.split(".")[1];
    let imgList = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'];
    return imgList.includes(type);
};

// 数组删除 arr:数组 att: 数组的属性 value: 对比相同的值 type: 返回的格式(json)
export function arrAttDel(arr, att, value, type = ''){
  let newArr = [];
  for(let i in arr){
    let item = arr[i];
    if(att === 'item'){
      if(item === value){
        arr.splice(i, 1);
        newArr = arr;
      }
    }else{
      if(item[att] === value){
        arr.splice(i, 1);
        newArr = arr;
      }
    }
  }
  let res = '';
  if(type === 'json'){
    res = JSON.stringify(newArr)
  }else if(type === 'string'){
    res = newArr.legnth > 1 ? newArr.join(',') : newArr.toString();
  }
  return res;
};

// 深拷贝
export function deepClone(obj) {
  let result = typeof  obj.splice === "function" ? [] : {};
  if (obj && typeof obj === 'object') {
      for (let key in obj) {
          if (obj[key] && typeof obj[key] === 'object') {
              result[key] = deepClone(obj[key]);//如果对象的属性值为object的时候，递归调用deepClone,即在吧某个值对象复制一份到新的对象的对应值中。
          } else {
              result[key] = obj[key];//如果对象的属性值不为object的时候，直接复制参数对象的每一个键值到新的对象对应的键值对中。
          }

      }
      return result;
  }
  return obj;
}

//滚动到第一个错误处
export function goFirstError() {
  setTimeout(() => {
    let isError = document.getElementsByClassName("el-form-item__error");
    isError[0].scrollIntoView({
      // 滚动到指定节点
      // 值有start,center,end，nearest，当前显示在视图区域中间
      block: "center",
      // 值有auto,smooth，缓动动画（当前是慢速的）
      behavior: "smooth",
    });
  }, 100);
}